export type CustomLocation = {
  href: string;
  origin: string;
  pathname: string;
  search: string;
  hash: string;
};

export type BaseGetEvent = {
  timestamp: number;
  location: CustomLocation;
  description: string | undefined;
};

export interface IBaseEvent {
  toJSON(): BaseGetEvent;
}

export default abstract class BaseEvent implements IBaseEvent {
  protected timestamp: number;

  protected location: CustomLocation;

  protected description: string | undefined;

  constructor(description: string | undefined) {
    this.timestamp = new Date().getTime();
    const { href, origin, pathname, search, hash } = window.location;
    this.location = { href, origin, pathname, search, hash };
    this.description = description;
  }

  toJSON() {
    return {
      timestamp: this.timestamp,
      location: this.location,
      description: this.description,
    };
  }
}
